<template>
  <integral></integral>
</template>

<script>
import integral from "place/drawactivity/integral.vue";
export default {
  components: {
    integral,
  },
};
</script>
<style lang="scss" scoped></style>
